// src/components/termOfPayments/Table/TermOfPaymentsTableColumns.jsx

const TermOfPaymentsTableColumns = [
    { id: "id", labelAr: "المعرف", labelEn: "ID", sortable: true },
    { id: "code", labelAr: "الكود", labelEn: "Code", sortable: true },
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default TermOfPaymentsTableColumns;